import React, { Component } from 'react';
import ReactTable from 'react-table';
import VendorInfoDialog from './VendorInfoDialog';
import 'react-table/react-table.css';
import './AppPage.css';
import { startsWith } from 'helpers/StringHelper';
import { getTranslatedString } from 'helpers/i18n';

class VendorsTable extends Component {
  constructor(props) {
    super(props);
    const tableSize = props.data && props.data.length > 0 ? props.data.length : 4;
    this.state = {
      tableSize,
      data: this.props.data,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(
      {
        tableSize: nextProps.data.length === 0 ? 4 : nextProps.data.length,
        data: nextProps.data,
      },
      function() {
        this.forceUpdate();
      }
    );
  }

  handleOpen = (vendor_id, vendorDetails) => {
    this.props.openVendorInfoDialog(vendorDetails);
  };

  render() {
    const columns = [
      {
        header: getTranslatedString('landlordPortal.vendors.name'),
        headerClassName: 'headerColumn',
        accessor: 'name',
      },
      {
        header: getTranslatedString('landlordPortal.vendors.contactNumber'),
        headerClassName: 'headerColumn',
        accessor: 'contact_number',
      },
      {
        header: getTranslatedString('landlordPortal.vendors.contactEmail'),
        headerClassName: 'headerColumn',
        accessor: 'contact_email',
      },
      {
        header: getTranslatedString('landlordPortal.vendors.classification'),
        headerClassName: 'headerColumn',
        accessor: 'classification',
      },
      {
        header: 'Action',
        headerClassName: 'headerColumn',
        accessor: 'id',
        render: row => (
          <button
            type="button"
            className="link-button"
            onClick={() => this.handleOpen(row.value, row.row)}
            style={{ cursor: 'pointer' }}
          >
            {getTranslatedString('landlordPortal.vendors.viewDetails')}
          </button>
        ),
      },
    ];

    return (
      <div>
        <VendorInfoDialog
          vendorDetails={this.props.vendorDetails}
          vendorDialogIsOpen={this.props.vendorDialogIsOpen}
          openEditVendorDialog={this.props.openEditVendorDialog}
          closeVendorInfoDialog={this.props.closeVendorInfoDialog}
          deleteVendor={this.props.deleteVendor}
        />

        <div style={{ marginBottom: '70px' }}>
          <ReactTable
            data={this.state.data}
            columns={columns}
            showFilters={false}
            showPagination={false}
            showPageSizeOptions={false}
            pageSize={this.state.tableSize}
            defaultFilterMethod={(filter, row, column) => {
              const id = filter.pivotId || filter.id;
              return row[id] !== undefined
                ? startsWith(String(row[id]).toLowerCase(), filter.value)
                : true;
            }}
            noDataText={getTranslatedString('landlordPortal.vendors.noVendors')}
          />
        </div>
      </div>
    );
  }
}

export default VendorsTable;
